<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <form [formGroup]="demoRequestForm" *ngIf="showForm">
    <div class="formGrid">

      <div class="fullWidth nameInfo">
        <mat-form-field>
          <mat-label>Anrede</mat-label>
          <mat-select [formControl]="gender">
            <mat-option *ngFor="let gender of genders" [value]="gender.value">{{gender.label}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Vorname</mat-label>
          <input matInput [formControl]="firstname" autocomplete="given-name" required />
          <mat-error *ngIf="firstname.hasError">Diese Angabe ist erforderlich</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Nachname</mat-label>
          <input matInput [formControl]="lastname" autocomplete="family-name" required />
          <mat-error *ngIf="lastname.hasError">Diese Angabe ist erforderlich</mat-error>
        </mat-form-field>
      </div>
      <mat-form-field>
        <mat-label>E-Mail</mat-label>
        <input type="email" matInput [formControl]="email" autocomplete="email" pattern="[^@]+@[^@]+\.[^@]+"
          required />
        <mat-error *ngIf="email.hasError">
          Bitte eine valide E-Mail angeben
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Telefonnummer</mat-label>
        <input type="tel" matInput [formControl]="phoneNumber" autocomplete="tel"
          (blur)="checkAndSetPhonenumber()" />
        <mat-error *ngIf="phoneNumber.invalid && phoneNumber.value">
          Bitte eine gültige Telefonnummer angeben
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Organisation</mat-label>
        <input matInput [formControl]="company" autocomplete="organization" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Website</mat-label>
        <input matInput [formControl]="url" autocomplete="url" type="url"/>
        <mat-error *ngIf="url.hasError('websiteLength')">
          Die Website darf maximal 60 Zeichen lang sein
        </mat-error>
        <mat-error *ngIf="url.hasError('invalidUrl') && !url.hasError('websiteLength')">
          Bitte eine valide Website angeben
        </mat-error>
      </mat-form-field>
      <mat-form-field class="fullWidth">
        <mat-label>Anfrage</mat-label>
        <textarea [formControl]="request" matInput required maxlength="1000" rows="5"></textarea>
        <mat-error>Diese Angabe ist erforderlich.</mat-error>
      </mat-form-field>
    </div>
    <p>
      Mit Absenden des Formulars akzeptieren Sie die
      <a (click)="showAgb()">AGB</a>
      und
      <a (click)="showPrivacy()">Datenschutzerklärung</a>.
    </p>
  </form>
  <div *ngIf="showDemoSuccessMessage">
    <p>
      Vielen Dank für Ihre Anfrage. Ihr Formular wurde erfolgreich an den
      Anbieter weitergeleitet und er meldet sich demnächst bei Ihnen, um einen
      Demo-Termin zu vereinbaren.
    </p>
  </div>
  <div *ngIf="showOfferSuccessMessage">
    <p>
      Vielen Dank für Ihre Anfrage. Ihr Formular wurde erfolgreich an den
      Anbieter weitergeleitet und er meldet sich demnächst bei Ihnen, um Ihre
      Anfrage zu beantworten.
    </p>
  </div>
  <div *ngIf="showListingSuccessMessage">
    <p>
      Vielen Dank für Ihre Anfrage. Ihre Anfrage wurde erfolgreich gestellt. Wir melden uns in Kürze bei Ihnen, um Ihre
      Anfrage zu beantworten.
    </p>
  </div>
  <div *ngIf="showErrorMessage">
    <p>
      Leider ist bei der Anfrage ein Fehler aufgetreten. Bitte versuchen sie es
      später erneut.
    </p>
  </div>
  <div *ngIf="showNoContactMail">
    <p>
      Leider konnte die Anfrage nicht gesendet werden, da die Organisation keine
      Kontaktadresse hinterlegt hat.
    </p>
  </div>
  <div *ngIf="showWaitForResult">
    <p>Bitte warten</p>
  </div>
</div>
<div mat-dialog-actions [align]="'end'">
  <button style="width: 125px" matButton="elevated" class="green-confirm" (click)="onSubmit()"
    [disabled]="demoRequestForm.invalid" *ngIf="showForm">
    Senden
  </button>
  <button style="width: 125px" matButton="elevated" color="warn" *ngIf="showForm" (click)="cancel()">
    Abbrechen
  </button>
  <button style="width: 125px" matButton="elevated" color="warn" *ngIf="!showForm" (click)="cancel()">
    Schließen
  </button>


</div>